import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function putUpdateQuiz(uuid: any, quiz: any): Promise<void> {
    const { apiPutUpdateQuiz } = apiConfig.getStaticUrls();

    const path = `${apiPutUpdateQuiz}${uuid}/`;

    return postFetch(path, quiz);
}

